exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal__header[data-v-2893e462]{height:48px}.modal__content[data-v-2893e462]{width:100%;overflow-y:auto;padding:8px 10px}.loading-background[data-v-2893e462]{background-color:hsla(0,0%,100%,.4)}.important-note[data-v-2893e462]{font-size:19px}.name[data-v-2893e462]{padding-left:16px}.middle[data-v-2893e462]{padding:3px}.food-img[data-v-2893e462]{border-radius:7px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2893e462","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/PromoItemsDialog.vue
// module id = UECd
// module chunks = 0